import Token from '@/utils/Token';

const MOTIVO_MAX_CARACTERES = 10000;

export default {
    MOTIVO_MAX_CARACTERES,
    parse(data) {
        if (!data) {
            return data;
        }

        ['data_solicitacao', 'concluido_em'].forEach((field) => {
            if (data[field]) {
                data[field] = this.parseDateField(data[field]);
            }
        });

        if (!data.solicitante && data.solicitante_descricao) {
            data.solicitante = data.solicitante_descricao;
        }
        if (!data.usuario && data.usuario_nome) {
            data.usuario = data.usuario_nome;
        }
        if (!data.created_by_nome && data.usuario_nome) {
            data.created_by_nome = data.usuario_nome;
        }

        return data;
    },

    parseDashboardResponse(response) {
        const body = response?.data ?? {};
        const data = body.data ?? body;

        const parsed = {
            abertos: Number(data.abertos ?? 0),
            em_andamento: Number(data.em_andamento ?? 0),
            concluidos: Number(data.concluidos ?? 0),
            rejeitados: Number(data.rejeitados ?? 0),
        };

        parsed.total_abertos = parsed.abertos + parsed.em_andamento;

        return parsed;
    },

    fetchDashboard(params = '') {
        return this.dashboard(params).then((response) => this.parseDashboardResponse(response));
    },

    parseDateField(value) {
        if (!value) {
            return null;
        }
        if (value instanceof Date) {
            return Number.isNaN(value.getTime()) ? null : value;
        }

        let raw = String(value).trim();
        if (raw.includes(' ') && !raw.includes('T')) {
            raw = raw.replace(' ', 'T');
        }
        if (!raw.includes('T')) {
            raw = `${raw}T00:00:00`;
        }

        const parsed = new Date(raw);

        return Number.isNaN(parsed.getTime()) ? null : parsed;
    },

    parseShowResponse(response) {
        const body = response?.data ?? {};
        const data = body.data ?? body;

        if (data.cancelamento) {
            return this.parse({
                ...data.cancelamento,
                workflow: data.workflow ?? data.cancelamento.workflow ?? null,
            });
        }

        return this.parse(data);
    },

    parseCreateResponse(response) {
        const body = response?.data ?? {};
        return this.parse(body.data ?? body);
    },

    extractErrorMessage(error) {
        const err = error?.response?.data;
        if (err?.msg) {
            return err.msg;
        }
        if (err?.message) {
            return err.message;
        }
        if (error?.message) {
            return error.message;
        }
        return 'Ocorreu um erro inesperado.';
    },

    get(id, params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/cancelamento/${id}${params}`, Token.getHeader());
    },

    list(params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/cancelamento/list${params}`, Token.getHeader());
    },

    download(params = '') {
        if (params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/cancelamento/download${params}`, headers);
    },

    listContrato(contratoId, params = '') {
        const filter = `filter[contrato_id]=${contratoId}`;
        const query = params ? `${params}&${filter}` : filter;
        return this.list(query);
    },

    option(params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/cancelamento/option${params}`, Token.getHeader());
    },

    dashboard(periodo = 30) {
        const val = periodo || 30;
        return axios.get(`/api/cancelamento/dashboard?periodo=${val}`, Token.getHeader());
    },

    create(params) {
        return axios.post('/api/cancelamento', params, Token.getHeader());
    },

    porContrato(contratoId) {
        return axios.get(`/api/cancelamento/por-contrato/${contratoId}`, Token.getHeader());
    },
};
